// Getters
export const SERIES_TYPES = 'groupSeries/SERIES_TYPES'
export const SERIES_REPETITION_TYPES = 'groupSeries/SERIES_REPETITION_TYPES'
export const SERIES_MONTHLY_REPETITION_TYPES = 'groupSeries/SERIES_MONTHLY_REPETITION_TYPES'
export const DUTY_VALUE_SOURCE_TYPES = 'groupSeries/DUTY_VALUE_SOURCE_TYPES'
export const SERIES_SEARCH_RESULTS = 'groupSeries/SERIES_SEARCH_RESULTS'

// Mutations
export const MUTATE_SERIES_TYPES = 'groupSeries/MUTATE_SERIES_TYPES'
export const MUTATE_SERIES_REPETITION_TYPES = 'groupSeries/MUTATE_SERIES_REPETITION_TYPES'
export const MUTATE_SERIES_MONTHLY_REPETITION_TYPES = 'groupSeries/MUTATE_SERIES_MONTHLY_REPETITION_TYPES'
export const MUTATE_DUTY_VALUE_SOURCE_TYPES = 'groupSeries/MUTATE_DUTY_VALUE_SOURCE_TYPES'
export const MUTATE_SERIES_SEARCH_RESULTS = 'groupSeries/MUTATE_SERIES_SEARCH_RESULTS'

// Actions
export const GET_SERIES_TYPES = 'groupSeries/GET_SERIES_TYPES'
export const GET_SERIES_REPETITION_TYPES = 'groupSeries/GET_SERIES_REPETITION_TYPES'
export const GET_SERIES_MONTHLY_REPETITION_TYPES = 'groupSeries/GET_SERIES_MONTHLY_REPETITION_TYPES'
export const SAVE_SERIES = 'groupSeries/SAVE_SERIES'
export const GET_DUTY_VALUE_SOURCE_TYPES = 'groupSeries/GET_DUTY_VALUE_SOURCE_TYPES'
export const SEARCH_SERIES = 'groupSeries/SEARCH_SERIES'
export const DELETE_SERIES = 'groupSeries/DELETE_SERIES'
export const GET_SERIES_BY_ID = 'groupSeries/GET_SERIES_BY_ID'
